import { ProFormSwitch } from '@ant-design/pro-form';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SwitchFormType } from '@/presentation/components/form/index';

export const SwitchForm: FC<{ entry: SwitchFormType, hidden?: boolean }> = (props) => {
  const { name, label, transform, convertValue } = props.entry;
  const { t } = useTranslation();

  return <ProFormSwitch
    transform={transform}
    convertValue={convertValue}
    unCheckedChildren={t('否')}
    checkedChildren={t('是')}
    name={name}
    label={label}
    hidden={props.hidden}
  />;
};
